import React from 'react';

const GoBackIcon = ({ style }) => {
  return (
    <svg id="뒤로가기" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path id="Path_6534" data-name="Path 6534" d="M0,0H24V24H0Z" fill="none" />
      <circle id="Ellipse_96" data-name="Ellipse 96" cx="11" cy="11" r="11" transform="translate(1 1)" fill="#3a3a3a" />
      <path
        id="Path_6535"
        data-name="Path 6535"
        d="M6.393,8.579H14V9.865H6.393l3.352,3.448-.884.909L4,9.222l4.861-5,.884.909Z"
        transform="translate(3 2.778)"
        fill="#fff"
      />
    </svg>
  );
};

export default GoBackIcon;
